// Export analytics utilities
export {
  clearPageTracking,
  getPageNameAnalytics,
  getSelectedCountriesFromLocalStorage,
} from "./analyticsUtils";
// Export types
export * from "./types";
export {
  initializeErrorPageTracking,
  initializePageTracking,
  trackComponentView,
  trackEvent,
  triggerPageExit,
  updateSearchContext,
} from "./xdmEvents";
